var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getDuration())?_c('div',{staticClass:"video-card-duration-container"},[_c('b',[_vm._v("Duration:")]),_vm._v(" "),_c('span',{staticClass:"video-card-duration-time"},[_vm._v(_vm._s(_vm.getDuration()))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }